import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchDirectCustomers,
    fetchSuccessList,
    fetchSuccessListEntryHistory,
    fetchSuccessListOverview,
    fetchSuccessListRegions,
    fetchSuccessListTopics,
} from 'src/api/success-list';
import {
    FETCH_DIRECT_CUSTOMERS,
    FETCH_SUCCESS_LIST,
    FETCH_SUCCESS_LIST_ENTRY_HISTORY,
    FETCH_SUCCESS_LIST_OVERVIEW,
    FETCH_SUCCESS_LIST_REGIONS,
    FETCH_SUCCESS_LIST_TOPICS,
    requestDirectCustomers,
    requestDirectCustomersFailure,
    requestDirectCustomersSuccess,
    requestSuccessList,
    requestSuccessListEntryHistory,
    requestSuccessListEntryHistoryFailure,
    requestSuccessListEntryHistorySuccess,
    requestSuccessListFailure,
    requestSuccessListOverview,
    requestSuccessListOverviewFailure,
    requestSuccessListOverviewSuccess,
    requestSuccessListRegions,
    requestSuccessListRegionsFailure,
    requestSuccessListRegionsSuccess,
    requestSuccessListSuccess,
    requestSuccessListTopics,
    requestSuccessListTopicsFailure,
    requestSuccessListTopicsSuccess,
} from './actions';

/*  Direct Customers  */
function* fetchDirectCustomersSaga(action: AnyAction): SagaIterator {
    yield put(requestDirectCustomers());

    const { error, response } = yield call(fetchDirectCustomers);

    if (error) yield put(requestDirectCustomersFailure(error));
    else yield put(requestDirectCustomersSuccess(response));
}

export function* generateFetchDirectCustomersWatcher() {
    yield takeLatest(FETCH_DIRECT_CUSTOMERS, fetchDirectCustomersSaga);
}

/* Succes List Overview */
function* fetchSuccessListOverviewSaga(action: AnyAction): SagaIterator {
    yield put(requestSuccessListOverview());

    const { error, response } = yield call(fetchSuccessListOverview);

    if (error) yield put(requestSuccessListOverviewFailure(error));
    else yield put(requestSuccessListOverviewSuccess(response));
}

export function* generateFetchSuccessListOverviewWatcher() {
    yield takeLatest(FETCH_SUCCESS_LIST_OVERVIEW, fetchSuccessListOverviewSaga);
}

/* Success List Topics */
function* fetchSuccessListTopicsSaga(action: AnyAction): SagaIterator {
    yield put(requestSuccessListTopics());

    const { error, response } = yield call(fetchSuccessListTopics);

    if (error) yield put(requestSuccessListTopicsFailure(error));
    else yield put(requestSuccessListTopicsSuccess(response));
}

export function* generateFetchSuccessListTopicsWatcher() {
    yield takeLatest(FETCH_SUCCESS_LIST_TOPICS, fetchSuccessListTopicsSaga);
}

/* Success List */
function* fetchSuccessListSaga(action: AnyAction): SagaIterator {
    yield put(requestSuccessList());

    const { error, response } = yield call(fetchSuccessList, action.topic, action.pageable, action.personArch);

    if (error) yield put(requestSuccessListFailure(error));
    else yield put(requestSuccessListSuccess(response));
}

export function* generateFetchSuccessListWatcher() {
    yield takeLatest(FETCH_SUCCESS_LIST, fetchSuccessListSaga);
}

/* Success List Entry History */
function* fetchSuccessListEntryHistorySaga(action: AnyAction): SagaIterator {
    yield put(requestSuccessListEntryHistory());

    const { error, response } = yield call(fetchSuccessListEntryHistory, action.nameListEntryId);

    if (error) yield put(requestSuccessListEntryHistoryFailure(error));
    else yield put(requestSuccessListEntryHistorySuccess(response));
}

export function* generateFetchSuccessListEntryHistoryWatcher() {
    yield takeLatest(FETCH_SUCCESS_LIST_ENTRY_HISTORY, fetchSuccessListEntryHistorySaga);
}

/* Success List Regions */
function* fetchSuccessListRegionsSaga(action: AnyAction): SagaIterator {
    yield put(requestSuccessListRegions());

    const { error, response } = yield call(fetchSuccessListRegions);

    if (error) yield put(requestSuccessListRegionsFailure(error));
    else yield put(requestSuccessListRegionsSuccess(response));
}

export function* generateFetchSuccessListRegionsWatcher() {
    yield takeLatest(FETCH_SUCCESS_LIST_REGIONS, fetchSuccessListRegionsSaga);
}
